// extracted by mini-css-extract-plugin
export var container = "_a8-0";
export var icon = "_a8-1";
export var text = "_a8-2";